import React from 'react';
import NotificationSettings from '../../components/notifications/NotificationSettings';

const ProfilePage = () => {
    return (
        <div>
            <h3 style={{ marginBottom: "2rem" }}>Mange Notifications</h3>
            <NotificationSettings />
        </div>
    );
};

export default ProfilePage;